
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIcon120Like = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 120,
  height: 120,
  viewBox: "0 0 120 120",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M51.733 107h-12.72a10.983 10.983 0 0 1-10.785-8.89l-4.713-17.028c-4.195-11.898-2.369-18.229-.094-21.447a9.466 9.466 0 0 1 7.924-4.102h10.422a41.152 41.152 0 0 1 .435-12.907c2.534-10.137 8.083-10.58 10.345-10.3 3.538.435 6.76 3.518 6.76 6.467a19.532 19.532 0 0 0 5.19 14.53c5.279 5.28 14.806 6.693 14.9 6.707a2.632 2.632 0 0 1-.743 5.211c-.462-.065-11.373-1.688-17.88-8.195a24.615 24.615 0 0 1-6.73-18.11 3.095 3.095 0 0 0-2.486-1.4c-1.681.067-3.27 2.448-4.25 6.367-1.341 5.368.03 13.747.043 13.83a2.632 2.632 0 0 1-2.596 3.065h-13.41a4.22 4.22 0 0 0-3.626 1.876c-1.03 1.457-3.014 6.004.788 16.739.02.058.039.117.056.176l4.767 17.222c.02.076.039.152.053.23a5.722 5.722 0 0 0 5.63 4.695h12.72c9.685 0 22.607-2.156 25.404-5.042a2.632 2.632 0 1 1 3.78 3.664C75.66 105.78 57.633 107 51.732 107z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("path", {
  d: "M96.368 106.659H79.026a2.632 2.632 0 0 1-2.632-2.632V59.224a2.632 2.632 0 0 1 2.632-2.632h17.342A2.632 2.632 0 0 1 99 59.224v44.803a2.632 2.632 0 0 1-2.632 2.632z",
  fill: "var(--theme-primary, #810ea9)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--theme-primary, #810ea9)",
  d: "M81.658 101.395h12.079V61.856h-12.08zM51.334 26.706a2.632 2.632 0 0 1-2.632-2.632v-7.442a2.632 2.632 0 1 1 5.263 0v7.442a2.632 2.632 0 0 1-2.631 2.632zm13.562 7.696a2.632 2.632 0 0 1-1.36-4.887l6.377-3.837a2.631 2.631 0 1 1 2.714 4.509l-6.376 3.838a2.623 2.623 0 0 1-1.355.377zm-27.123 0c-.477 0-.946-.13-1.354-.377l-6.377-3.838a2.632 2.632 0 0 1 2.714-4.509l6.376 3.837a2.632 2.632 0 0 1-1.36 4.887z"
}))));

      const __svgRaw = "<svg width=\"120\" height=\"120\" viewBox=\"0 0 120 120\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <g fill-rule=\"nonzero\" fill=\"none\">\r\n        <path d=\"M51.733 107h-12.72a10.983 10.983 0 0 1-10.785-8.89l-4.713-17.028c-4.195-11.898-2.369-18.229-.094-21.447a9.466 9.466 0 0 1 7.924-4.102h10.422a41.152 41.152 0 0 1 .435-12.907c2.534-10.137 8.083-10.58 10.345-10.3 3.538.435 6.76 3.518 6.76 6.467a19.532 19.532 0 0 0 5.19 14.53c5.279 5.28 14.806 6.693 14.9 6.707a2.632 2.632 0 0 1-.743 5.211c-.462-.065-11.373-1.688-17.88-8.195a24.615 24.615 0 0 1-6.73-18.11 3.095 3.095 0 0 0-2.486-1.4c-1.681.067-3.27 2.448-4.25 6.367-1.341 5.368.03 13.747.043 13.83a2.632 2.632 0 0 1-2.596 3.065h-13.41a4.22 4.22 0 0 0-3.626 1.876c-1.03 1.457-3.014 6.004.788 16.739.02.058.039.117.056.176l4.767 17.222c.02.076.039.152.053.23a5.722 5.722 0 0 0 5.63 4.695h12.72c9.685 0 22.607-2.156 25.404-5.042a2.632 2.632 0 1 1 3.78 3.664C75.66 105.78 57.633 107 51.732 107z\" fill=\"#000\"/>\r\n        <path d=\"M96.368 106.659H79.026a2.632 2.632 0 0 1-2.632-2.632V59.224a2.632 2.632 0 0 1 2.632-2.632h17.342A2.632 2.632 0 0 1 99 59.224v44.803a2.632 2.632 0 0 1-2.632 2.632z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n        <path fill=\"var(--theme-primary, #810ea9)\" d=\"M81.658 101.395h12.079V61.856h-12.08zM51.334 26.706a2.632 2.632 0 0 1-2.632-2.632v-7.442a2.632 2.632 0 1 1 5.263 0v7.442a2.632 2.632 0 0 1-2.631 2.632zM64.896 34.402a2.632 2.632 0 0 1-1.36-4.887l6.377-3.837a2.631 2.631 0 1 1 2.714 4.509l-6.376 3.838a2.623 2.623 0 0 1-1.355.377zM37.773 34.402c-.477 0-.946-.13-1.354-.377l-6.377-3.838a2.632 2.632 0 0 1 2.714-4.509l6.376 3.837a2.632 2.632 0 0 1-1.36 4.887z\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icon-120-like.ed9e4c52887a369efa1591229d06053f.svg"),
        {
          React: SvgIcon120Like,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      